import React, { useState, useEffect, useRef } from "react";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { getAddressSuggestions, getFullAddress, getStreetOnly, getPlaceInfo } from "../context/geoPlace";



export default function AwsLocationAutocomplete({ serviceType, updateFormData, setDisableFormSubmitBtn}) {
    const [inputValue, setInputValue] = useState("");
    const [query, setQuery] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const streerAddressInputRef = useRef(null);
    const containerRef = useRef(null);
    let DOMRect = streerAddressInputRef?.current?.getBoundingClientRect();
    const controllerRef = useRef(null);
    const skipNextQuery = useRef(false); // 🔹 NEW FLAG

    //Debounce typing
    useEffect(() => {
        /* if (!inputValue) {
             setSuggestions([]);
             return;
         }*/

        // if programmatic (after selection), skip
        if (skipNextQuery.current) {
            skipNextQuery.current = false;
            return;
        }

        const handler = setTimeout(() => {
            setQuery(inputValue);
        }, 400);

        return () => clearTimeout(handler);
    }, [inputValue]);

    //Fetch AWS suggestions
    useEffect(() => {
        // if (!query) return;
        if (query === "") {
            setQuery(" ");
            updateFormData({ zipCode : "" });
            updateFormData({ city: "" });
            updateFormData({ state: "CA" });
        }
        if (controllerRef.current) {
            controllerRef.current.abort();
        }
        const controller = new AbortController();
        controllerRef.current = controller;
        // DOMRect = streerAddressInputRef.current.getBoundingClientRect();
        const fetchData = async () => {
            setLoading(true);
            const { results, error } = await getAddressSuggestions(query, controller.signal);            
            setSuggestions(results);
            setError(error);
            setLoading(false);
            setShowDropdown(true);
        };

        fetchData();
    }, [query]);

    //Handle suggestion selection
    async function handleSelect(suggestion) {

        // suggestion = suggestion.Text.split(",")[0];
        skipNextQuery.current = true; // prevent debounce from firing API
        setShowDropdown(false);
        setSuggestions([]);
        setDisableFormSubmitBtn(true);        
        /*const placeInfo = await getPlaceInfo(suggestion.PlaceId);
        const streetAddress = [placeInfo.AddressNumber || "", placeInfo.Street].filter(Boolean).join(",");
        const [zipCode] = (placeInfo?.PostalCode ?? "").toString().split("-");*/
        const streetAddress = suggestion?.Address?.AddressNumber + ' ' + suggestion?.Address?.Street;
        const zipCode = suggestion?.Address?.PostalCode.split('-')[0] ?? "90245";
        setDisableFormSubmitBtn(false);
        setInputValue(streetAddress || suggestion.Title);
        updateFormData({ streetAddress });
        updateFormData({ zipCode });
        updateFormData({ city: suggestion?.Address?.Locality });
        updateFormData({ state: suggestion?.Address?.Region?.Code });

        //if (onSelect) onSelect(suggestion);
    }

    // Hide dropdown when clicking outside
    useEffect(() => {
        function handleClickOutside(e) {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setShowDropdown(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // Re-open suggestions on focus if input has text
    function handleFocus() {
        if (inputValue && suggestions.length > 0) {
            setShowDropdown(true);
        }
    }

    return (
        <div className="panel-label-input row" ref={containerRef}>
            <div className="col-md-4">
                <label htmlFor="in_care_of" className="">
                    <span className="text-danger">*</span>Street Address:
                </label>
            </div>
            <div className="pannel-input street-address-wrapper col-md-8">
                <div style={{ position: "relative" }}>
                    <input
                        type="text"
                        placeholder="Enter a location"
                        ref={streerAddressInputRef}
                        value={inputValue}
                        onFocus={handleFocus}
                        onChange={(e) => setInputValue(e.target.value)}
                        disabled={error}
                        style={{
                            // width: "100%",
                            padding: "8px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            //backgroundColor: error ? "#f8d7da" : "white",
                        }}
                    />
                    {error && (
                        <img
                            src="https://maps.gstatic.com/mapfiles/api-3/images/icon_error.png"
                            alt="error"
                            style={{
                                position: "absolute",
                                right: "8px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                width: "20px",
                                height: "20px",
                            }}
                        />
                    )}
                </div>

                {/* Progress bar */}
                {showDropdown && loading && !error && (
                    <div
                        style={{
                            position: "absolute",   // overlay instead of pushing
                            top: "30 px", //dynamic below input
                            left: "10px",
                            right: 0,          // directly below input
                            zIndex: 1000,           //on top of other elements
                            background: "#fff",
                            listStyle: "none",
                            padding: 0,
                            margin: "4px 0 0 0",
                            maxHeight: "200px",
                            width: DOMRect.width,
                            overflowY: "auto",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
                            padding: "10px 20px"
                        }}
                    // style={{
                    //     position: "relative",
                    //     height: "3px",
                    //     width: "100%",
                    //     backgroundColor: "#039",
                    //     overflow: "hidden",
                    //     marginTop: "2px",
                    //     borderRadius: "2px",
                    // }}
                    >
                        <Skeleton duration={3} height={5} width={DOMRect.width - 40} />
                        <Skeleton duration={3} height={5} width={DOMRect.width - 100} />
                        <Skeleton duration={3} height={5} width={DOMRect.width - 40} />
                        <Skeleton duration={3} height={5} width={DOMRect.width - 100} />
                        <Skeleton duration={3} height={5} width={DOMRect.width - 40} />
                        <Skeleton duration={3} height={5} width={DOMRect.width - 100} />
                        <Skeleton duration={3} height={5} width={DOMRect.width - 40} />
                        <Skeleton duration={3} height={5} width={DOMRect.width - 100} />

                        <div
                        // style={{

                        //     position: "absolute",
                        //     top: 0,
                        //     left: "-40%",
                        //     height: "100%",
                        //     width: "40%",
                        //     /*background:
                        //       "linear-gradient(to right, transparent, rgba(255,255,255,0.6), transparent)",*/
                        //     animation: "shimmer 1.2s linear infinite",
                        // }}
                        />
                    </div>
                )}

                {/* Suggestions dropdown */}
                {showDropdown && !loading && !error && suggestions.length > 0 && (

                    <ul style={{
                        position: "absolute",   //overlay instead of pushing
                        top: "30px", //dynamic below input
                        left: "10px",
                        right: 0,          // directly below input
                        zIndex: 1000,           //on top of other elements
                        background: "#fff",
                        listStyle: "none",
                        padding: 0,
                        margin: "4px 0 0 0",
                        maxHeight: "200px",
                        width: DOMRect.width,
                        overflowY: "auto",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
                    }}
                    >
                        {suggestions.map((s, i) => (
                           
                            <li
                                key={i}
                                onClick={() => handleSelect(s)}
                                title={s.Title}
                                style={{
                                    cursor: "pointer",
                                    padding: "6px 8px",
                                    borderBottom: "1px solid #eee",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis"
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.background = "#f5f5f5")}
                                onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
                            >
                                {s?.Address?.AddressNumber + ' ' + s?.Address?.Street + ', '+ s?.Address?.Locality + ', ' + s?.Address?.Region?.Code}
                            </li>
                        ))}
                    </ul>
                )
                }

                <style>
                    {`
          @keyframes shimmer {
            0% { left: -40%; }
            100% { left: 100%; }
          }
        `}
                </style>
            </div>
        </div>
    );
}

